import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { generateTestId } from '@vs/functions/generate-test-id';
import { onEnterTriggerClick } from '@vs/functions/on-enter-trigger-click';
import { ReactNode, useId } from 'react';

export interface PortalBackButtonProps {
  children: ReactNode;
  onClick: () => void;
}

export function PortalBackButton({ children, onClick }: PortalBackButtonProps) {
  const id = useId();
  return (
    <div className="flex justify-end">
      <div
        {...generateTestId('btn-like', ['to-prev-view'])}
        className="inline-flex h-6 cursor-pointer items-center mb-4 md:mb-0"
        tabIndex={0}
        role="button"
        onClick={onClick}
        onKeyDown={onEnterTriggerClick}
        aria-labelledby={id}
      >
        <KeyboardBackspaceIcon className="me-1 text-lg" aria-hidden="true" />
        <span
          id={id}
          className="vs-label-sm-medium text-vs-base-content hidden font-medium lg:block"
        >
          {children}
        </span>
      </div>
    </div>
  );
}

export default PortalBackButton;
